import { ApiError } from '../ApiError';

export class DataProviderError extends ApiError {
	constructor(
		message?: string,
		public status?: number
	) {
		let fullMessage = 'DataProvider';
		if (message) {
			fullMessage += `: ${message}`;
		}

		super(fullMessage, status);
	}
}
